import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=1bf8c7d0&scoped=true"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"
import style0 from "./FormTextarea.vue?vue&type=style&index=0&id=1bf8c7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8c7d0",
  null
  
)

export default component.exports